import styled, { css } from 'styled-components';

import { ButtonSquare } from '@xsolla/ui-core';

export const CopyInputWrapper = styled.div`
  display: flex;
`;

export const TitleStyles = css`
  font-size: 14px;
  line-height: 24px;
`;

export const InputTitle = styled.p`
  margin: 0;
  ${TitleStyles};
  color: ${(props) => props.theme.colors.muted};
`;

export const ExtraInputButton = styled(ButtonSquare)`
  margin-left: 8px;
`;

export const CopyTooltip = styled.div`
  position: absolute;
  top: 0;
`;

export const TooltipContent = styled.div``;
